import React, { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import IntelligencePageLayout from '@fuww/library/src/Layouts/IntelligencePage';
import Table, {
  TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@fuww/library/src/Table';
import SpacingContainer from '@fuww/library/src/SpacingContainer';
import Layout from '../components/Layout';
import messages from '../lib/messages.mjs';
import Hero from '../components/Hero';
import Head from '../components/Head';
import top200Companies from '../data/staticPages/i/top200.json';
import formatBigMoney from '../lib/formatBigMoney';
import generateIntelligencePageBreadcrumbs
  from '../lib/generateIntelligencePageBreadcrumbs';
import redirectRouteToDomain from '../lib/redirectRouteToDomain';

const headerImageUrls = {
  mobile: [
    'https://r.fashionunited.com/gpbLytN2LYPYfIhwo9cu4AQDPqx6nh5nlFBrrcY0Fdg/resize:fill:42:34:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/CbOBE34kZ7eiidTBhhxM2KI_W45DkREPGeCU2cQmBLQ/resize:fill:360:288:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfbW9iaWxlLmpwZw',
    'https://r.fashionunited.com/XHBqO0vMENfIOK0qPGm3hVE0jFNydpFE3OaSrSzL4Dw/resize:fill:720:576:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfbW9iaWxlLmpwZw',
  ],
  desktop: [
    'https://r.fashionunited.com/yo1Bm7O5G1iRbpDhuceGl-3yM2BQ-YirnvUqI87SbuQ/resize:fill:42:8:0/gravity:ce/quality:10/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/s75SLvcUrrurxmTrDUil8-d3WuY0bV_9OSeRm-wT9No/resize:fill:1350:277:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/GDbJH3LLwyRlM1xnRavBtG1ZFXC4x_TMOak44ed0Ycs/resize:fill:2560:526:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfZGVza3RvcC5qcGc',
    'https://r.fashionunited.com/eoSYDtKU70adsX_TNt2ZURiPOPcf09u2kFiMoS0NJnE/resize:fill:5120:1052:0/gravity:ce/quality:70/aHR0cHM6Ly9tZWRpYS5mYXNoaW9udW5pdGVkLmNvbS9tZWRpYS9pbWFnZXMvdG9wXzIwMF9iYW5uZXJfZGVza3RvcC5qcGc',
  ],
};

const Top200Page = () => {
  const intl = useIntl();

  const breadcrumbs = generateIntelligencePageBreadcrumbs(
    intl,
    'top200',
    'top200',
  );

  return (
    <>
      <Head
        title={intl.formatMessage(messages['top200.title'])}
        description={intl.formatMessage(messages['top200.description'])}
      />
      <IntelligencePageLayout
        description={
          intl.formatMessage(messages['top200.description'])
        }
        content={(
          <>
            <TableContainer>
              <Table aria-label={intl.formatMessage(
                messages[
                  'top200.table.ariaLabel'
                ])}
              >
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>{intl.formatMessage(messages.name)}</TableCell>
                    <TableCell align="right">
                      {intl.formatMessage(messages.marketCap)}
                    </TableCell>
                    <TableCell align="right">
                      {intl.formatMessage(messages.type)}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {top200Companies.map(({
                    name,
                    marketCap,
                    type,
                  }, index) => (
                    <TableRow key={name}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{name}</TableCell>
                      <TableCell align="right">
                        {formatBigMoney(marketCap)}
                      </TableCell>
                      <TableCell align="right">{type}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'top200.source'
              ]),
            }}
            />
            <SpacingContainer />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages[
                'top200.disclaimer'
              ]),
            }}
            />
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages.copyright),
            }}
            />
          </>
        )}
        breadcrumbs={breadcrumbs}
        subTitle={intl.formatMessage(messages['top200.subTitle'])}
        title={intl.formatMessage(messages['top200.title'])}
      />
    </>
  );
};

Top200Page.getLayout = (page: ReactElement) => (
  <Layout
    header={(
      <Hero
        imageUrls={headerImageUrls}
        alt="Top 200 companies banner image"
      />
    )}
  >
    {page}
  </Layout>
);

Top200Page.getInitialProps = redirectRouteToDomain('top200');

export default Top200Page;
